<div class="nxe-icons" nxeDragDrop (dragging)="dragging = $event">
  <div class="nxe-icons-drag" [ngClass]="{ dragging: dragging }"></div>
  <div class="nxe-icons-backpad" (click)="emptySpaceClick()"></div>
  <div class="nxe-icons-container drop-list_ pp0" [id]="parentItem.id+''"
       [class.dragging-element]="draggingelement"
       cdkDropList
       [cdkDropListConnectedTo]="connectedIds"
       cdkDropListSortingDisabled
  >
    <!-- (cdkDragReleased)="draggingState($event,false)"
    [cdkDropListData]="parentItem"
    [cdkDropListConnectedTo]="connectedButMe(parentItem)"
    (cdkDropListDropped)="onDragDropParent($event,parentItem)" -->
    @if (parentObj) {
      <!-- Parent folder dropzone -->
      <div class="drop-list-folder">
        <div class="drop drop-list drop-zone pp1" [id]="parentObj.id+''"
             cdkDropList
             [cdkDropListData]="parentObj"
             [cdkDropListConnectedTo]="connectedButMe(parentObj)"
             (cdkDropListDropped)="onDragDropParent($event,parentObj)">
          <!-- Parent folder dropzone -->
        </div>
        <div class="nxe-icons-wrapper " (dblclick)="open($event, parentObj)" (click)="select($event, parentObj)"
             [id]="'parentDroplist_'+parentObj.id" cdkDrag [cdkDragDisabled]="isSelected(parentObj)">
          <div class="nxe-icons-wrapper-inner" [ngClass]="{ 'nxe-icon-selected': isSelected(parentObj) }"
               [title]="parentObj.name">
            <div class="nxe-icons-icon">
              <i-tabler class="icon-32 icon-dir" name="dots"></i-tabler>
            </div>
            <div class="nxe-icon-text">{{ parentObj.name }}</div>
          </div>
        </div>


      </div>
    }


    @for (item of items; track $index) {
      @if (item.isLeaf) {
        <div class="drag-item nxe-icons-wrapper drop-list" [id]="item.id" (dblclick)="open($event, item)"
             (click)="select($event, item)" (cdkDragStarted)="onDragStart($event, item)" [cdkDragData]="selectedNodes"
             cdkDrag>
          <div class="nxe-icons-wrapper-inner" [ngClass]="{ 'nxe-icon-selected': isSelected(item) }"
               [title]="item.name">
            <div class="nxe-icons-icon" cdkDragHandle>
              @if (item.data['content_type'] === 'application/pdf') {
                <i-tabler class="icon-32 icon-file" name="file-type-pdf"></i-tabler>
              }
              @if (item.data['content_type'] === 'image/jpg' ||
              item.data['content_type'] === 'image/jpeg') {
                <i-tabler class="icon-32 icon-file" name="file-type-jpg"></i-tabler>
              }
              @if (item.data['content_type'] === 'image/png') {
                <i-tabler class="icon-32 icon-file" name="file-type-png"></i-tabler>
              }
              @if (isRagSupported(item)) {
                <span class="rag-dot" [ngClass]="'rag-dot--' + ragStatusClass(item)"
                      [title]="ragStatusTitle(item)"></span>
              }
            </div>
            <div class="nxe-icon-text">{{ item.name }}</div>
            @if (isRagSupported(item)) {
              <div class="rag-mini" (click)="$event.stopPropagation()" (dblclick)="$event.stopPropagation()">
          <span class="rag-badge" [ngClass]="'rag-badge--' + ragStatusClass(item)">
            @if (isRagProcessing(item)) {
              <i-tabler class="icon-16 rag-spin" name="loader-2"></i-tabler>
            }
            {{ ragStatusLabel(item) }}
          </span>
                <button type="button" class="rag-btn rag-btn--send"
                        [disabled]="!canSendToRag(item)"
                        [title]="ragSendLabel(item)"
                        (click)="sendToRag($event, item)">
                  <i-tabler class="icon-16" name="brain"></i-tabler>
                </button>
                <button type="button" class="rag-btn rag-btn--remove"
                        [disabled]="!canRemoveFromRag(item)"
                        [title]="ragRemoveLabel()"
                        (click)="removeFromRag($event, item)">
            <span class="brain-off">
                        <i-tabler class="icon-16" name="brain"></i-tabler>
                        <i-tabler class="icon-16 slash" name="slash"></i-tabler>
                      </span>
                </button>
              </div>
            }
          </div>
          <div *cdkDragPreview>
            @for (node of selectedNodes; track $index) {
              <div class="drag-item-preview">
                <i-tabler class="icon-24 icon-file" [name]="'file'"></i-tabler>
                <span class="nxe-icon-text">{{ node.name }}</span>
              </div>
            }
          </div>
          <div class="nxe-icon-placeholder" *cdkDragPlaceholder></div>

        </div>
      }
      @if (!item.isLeaf) {
        <div class="drop-list-folder">
          <div class="nxe-icons-wrapper " [id]="'folder-'+item.id" (dblclick)="open($event, item)"
               (click)="select($event, item)"
               (cdkDragStarted)="onDragStart($event, item)" [cdkDragData]="selectedNodes" cdkDrag>
            <div class="nxe-icons-wrapper-inner" [ngClass]="{ 'nxe-icon-selected': isSelected(item) }"
                 [title]="item.name">
              <div class="nxe-icons-icon" cdkDragHandle>
                <i-tabler class="icon-32 icon-dir" name="folder-filled"></i-tabler>
              </div>
              <div class="nxe-icon-text">{{ item.name }}</div>
            </div>
            <div *cdkDragPreview>
              @for (node of selectedNodes; track $index) {
                <div class="drag-item-preview">
                  <i-tabler class="icon-24 icon-file" [name]="'folder-filled'"></i-tabler>
                  <div class="nxe-icon-text">{{ node.name }}</div>
                </div>
              }
            </div>
            <div class="nxe-icon-placeholder" *cdkDragPlaceholder></div>
          </div>
          <div class="drop drop-list drop-zone pp3" [id]="item.id+''"
               cdkDropList
               [cdkDropListData]="item"
               [cdkDropListConnectedTo]="connectedButMe(item)"
               (cdkDropListDropped)="onDragDrop($event,item)">
            <!-- Child folder dropzone -->
          </div>

        </div>
      }
    }
  </div>
</div>
